import type { FC } from "react";
import { Icon } from "../../../components";

interface Props {
  count: number;
  onClick?: () => void;
}

const ExcelPrintButton: FC<Props> = (props) => {
  const { count, onClick } = props;

  if (count === 0) {
    return null;
  }

  return (
    <button type="button" className="excel-print-btn mr-3" onClick={onClick}>
      <Icon.Plus />
      Xuất Excel cho {count} lựa chọn
    </button>
  );
};

export default ExcelPrintButton;
